// Mock data for Ristorante Mezzaluna

export const restaurantInfo = {
  name: "Ristorante Mezzaluna",
  subtitle: {
    it: "da Rosi & Andrea",
    de: "von Rosi & Andrea",
    en: "by Rosi & Andrea"
  },
  tagline: {
    it: "Ristorante a conduzione familiare",
    de: "Familiär geführtes Restaurant",
    en: "Family-run restaurant"
  },
  description: {
    it: "Cucina italiana, pizza al forno a legna e specialità di pesce",
    de: "Italienische Küche, Holzofenpizza und Fischspezialitäten",
    en: "Italian cuisine, wood-fired pizza and fish specialties"
  },
  dailySpecial: {
    it: "✨ Ogni giovedì e venerdì proponiamo piatti fuori menu ✨",
    de: "✨ Jeden Donnerstag und Freitag bieten wir Gerichte außerhalb der Speisekarte an ✨",
    en: "✨ Every Thursday and Friday we offer dishes off the menu ✨"
  },
  address: "Via Nosette 21, 6595 Lavertezzo Piano",
  phone: "091 840 96 48",
  whatsapp: "0795673697",
  email: "ristorantemezzaluna@hotmail.com",
  googleMapsUrl: "https://maps.google.com/?q=Via+Nosette+21+Lavertezzo+Piano+Switzerland",
  googleReviewsUrl: "https://www.google.com/search?q=ristorante+mezzaluna+lavertezzo+recensioni",
  facebookUrl: "https://facebook.com/ristorante.mezzaluna.riazzino"
};

export const hours = [
  { day: { it: "Lunedì", de: "Montag", en: "Monday" }, hours: { it: "Chiuso", de: "Geschlossen", en: "Closed" }, closed: true },
  { day: { it: "Martedì", de: "Dienstag", en: "Tuesday" }, hours: "18:00 – 23:00" },
  { day: { it: "Mercoledì", de: "Mittwoch", en: "Wednesday" }, hours: "18:00 – 23:00" },
  { day: { it: "Giovedì", de: "Donnerstag", en: "Thursday" }, hours: "10:00 – 14:00 | 18:00 – 23:00" },
  { day: { it: "Venerdì", de: "Freitag", en: "Friday" }, hours: "10:00 – 14:00 | 18:00 – 23:00" },
  { day: { it: "Sabato", de: "Samstag", en: "Saturday" }, hours: "10:00 – 14:00 | 18:00 – 23:00" },
  { day: { it: "Domenica", de: "Sonntag", en: "Sunday" }, hours: "10:00 – 14:00 | 18:00 – 23:00" }
];

export const services = [
  { name: { it: "Pizza al Forno a Legna", de: "Holzofenpizza", en: "Wood-fired Pizza" }, icon: "Flame" },
  { name: { it: "Specialità di Pesce", de: "Fischspezialitäten", en: "Fish Specialties" }, icon: "Fish" },
  { name: { it: "Specialità di Carne", de: "Fleischspezialitäten", en: "Meat Specialties" }, icon: "Beef" },
  { name: { it: "Cucina Familiare", de: "Familienküche", en: "Family Cooking" }, icon: "Heart" }
];

export const images = {
  // Restaurant exterior with moon - HERO background (desktop)
  hero: "/images/hero.jpg",
  // Mobile hero background
  heroMobile: "/images/heroMobile.jpg",
  // Food images from user
  tagliata: "/images/tagliata.jpg",
  pasta: "/images/pasta.jpg",
  polpo: "/images/polpo.jpg",
  scoglio: "/images/scoglio.jpg",
  pizza: "/images/pizza.jpg",
  pollocestello: "/images/pollocestello.jpg",
  festapapa: "/images/festapapa.jpg",
  asparagi: "/images/asparagi.jpg",
  pasqua: "/images/pasqua.jpg",
  sanvalentino: "/images/sanvalentino.jpg",
  chiusura: "/images/chiusura.jpg",
  festamamma: "/images/festamamma.jpg",
  proposteEstive: "/images/proposteEstive.jpg",
  vini: "/images/vini.jpg",
  viniSpumanti: "/images/viniSpumanti.jpg",
  viniBianchi: "/images/viniBianchi.jpg",
  viniRosati: "/images/viniRosati.jpg",
  viniRossi1: "/images/viniRossi1.jpg",
  viniRossi2: "/images/viniRossi2.jpg",
  viniRossiTicinesi: "/images/viniRossiTicinesi.jpg",
  viniRossi3: "/images/viniRossi3.jpg",
  viniRossi4: "/images/viniRossi4.jpg"
};

// Food gallery for menu section
export const galleryImages = [
  { img: images.pizza, label: { it: "Pizza", de: "Pizza", en: "Pizza" } },
  { img: images.pasta, label: { it: "Pasta", de: "Pasta", en: "Pasta" } },
  { img: images.scoglio, label: { it: "Pesce", de: "Fisch", en: "Fish" } },
  { img: images.tagliata, label: { it: "Carne", de: "Fleisch", en: "Meat" } },
];


// Google Reviews
export const googleReviews = [
  {
    name: "Marco B.",
    text: {
      it: "Pizza fantastica! Il forno a legna fa davvero la differenza. Rosi e Andrea sono ospiti eccezionali.",
      de: "Fantastische Pizza! Der Holzofen macht wirklich den Unterschied. Rosi und Andrea sind außergewöhnliche Gastgeber."
    },
    rating: 5,
    lang: "IT",
    date: "2 settimane fa"
  },
  {
    name: "Anna K.",
    text: {
      it: "Ambiente familiare e rilassante. I frutti di mare sono sempre freschissimi. Consigliatissimo!",
      de: "Familiäre und entspannte Atmosphäre. Die Meeresfrüchte sind immer superfrisch. Sehr empfehlenswert!"
    },
    rating: 5,
    lang: "DE",
    date: "1 mese fa"
  },
  {
    name: "Stefan M.",
    text: {
      it: "La tagliata di manzo è spettacolare! Porzioni generose e prezzi onesti. Un vero gioiello a Lavertezzo.",
      de: "Das Tagliata ist spektakulär! Großzügige Portionen und faire Preise. Ein echtes Juwel in Lavertezzo."
    },
    rating: 5,
    lang: "DE",
    date: "3 settimane fa"
  },
  {
    name: "Giulia R.",
    text: {
      it: "Il pollo al cestello del sabato è da provare assolutamente! Prenotate in anticipo perché va a ruba.",
      de: "Das Hühnchen im Korb am Samstag ist ein Muss! Reservieren Sie im Voraus, es ist sehr beliebt."
    },
    rating: 5,
    lang: "IT",
    date: "1 settimana fa"
  },
  {
    name: "Thomas W.",
    text: {
      it: "Excellent cuisine! The pasta is homemade and you can taste the difference. Very welcoming staff.",
      de: "Ausgezeichnete Küche! Die Pasta ist hausgemacht und man schmeckt den Unterschied."
    },
    rating: 5,
    lang: "EN",
    date: "2 mesi fa"
  }
];

// Translations
export const translations = {
  it: {
    nav: {
      home: "Home",
      about: "Chi Siamo",
      menu: "Menu",
      specials: "Specialità",
      hours: "Orari",
      contact: "Contatti",
      book: "Prenota"
    },
    hero: {
      welcome: "Benvenuti al",
      features: [
        { title: "Cucina Italiana", subtitle: "Tradizione e qualità" },
        { title: "Forno a Legna", subtitle: "Pizza autentica" },
        { title: "Famiglia", subtitle: "Accoglienza calorosa" }
      ],
      cta1: "Prenota un tavolo",
      cta2: "Chiama ora",
      scroll: "Scorri"
    },
    about: {
      subtitle: "Chi Siamo",
      title: "Un Ristorante a Conduzione Familiare",
      welcome: "La Passione per la Cucina",
      p1: "Il Ristorante Mezzaluna nasce dall'amore per la buona cucina italiana, dalla cura per i dettagli e dal desiderio di far sentire ogni ospite come a casa.",
      p2: "Proponiamo piatti preparati con attenzione e ingredienti di qualità: specialità di pesce e carne, paste fatte con cura, pizza cotta nel forno a legna, selvaggina, Fondue Chinoise e dolci fatti con passione.",
      p3: "Un ambiente accogliente, un'atmosfera rilassante e una cucina sincera, da gustare in compagnia.",
      quote: "Dove la passione per la cucina si sente in ogni piatto.",
      stats: {
        fish: "Pesce Fresco",
        meat: "Carne di Qualità",
        pizza: "Forno a Legna",
        location: "Lavertezzo"
      }
    },
    menu: {
      subtitle: "Il Nostro Menu",
      title: "Una Cucina che Unisce Tradizione e Gusto",
      description: "Ogni piatto è preparato con cura, utilizzando ingredienti selezionati e rispettando la stagionalità.",
      daily: "Ogni giorno proponiamo anche il nostro menu del giorno.",
      cta: "Prenota un Tavolo",
      allergyNote: "In caso di allergie o intolleranze alimentari, invitiamo la nostra clientela a comunicarlo al personale prima dell'ordine."
    },
    specials: {
      subtitle: "Le Nostre Specialità",
      title: "Occasioni Speciali",
      chicken: {
        title: "Pollo al Cestello",
        subtitle: "Solo su prenotazione - Venerdì sera 20 marzo",
        description: "Un classico della nostra cucina, servito croccante e succulento."
      },
      festapapa: {
        title: "Festa del Papà",
        subtitle: "Giovedì 19 marzo",
        description: "Un menù speciale per celebrare tutti i papà."
      },
      valentine: {
        title: "San Valentino",
        subtitle: "Menu speciale per coppie",
        description: "Un menu romantico per celebrare l'amore con i sapori della nostra cucina."
      }
    },
    reviews: {
      subtitle: "Cosa Dicono di Noi",
      title: "Le Voci dei Nostri Ospiti",
      source: "Recensioni verificate su Google",
      seeAll: "Vedi tutte le recensioni su Google"
    },
    hours: {
      subtitle: "Quando Trovarci",
      title: "Orari di Apertura",
      weekly: "Orari Settimanali",
      today: "Oggi",
      services: "Le Nostre Specialità",
      note: "Nota Importante",
      noteText: "Per gruppi numerosi o occasioni speciali, vi consigliamo di prenotare in anticipo."
    },
    contact: {
      subtitle: "Vieni a Trovarci",
      title: "Prenota il Tuo Tavolo",
      info: "Informazioni di Contatto",
      phone: "Telefono",
      email: "Email",
      address: "Indirizzo",
      facebook: "Seguici su Facebook",
      form: {
        title: "Richiedi una Prenotazione",
        name: "Nome",
        email: "Email",
        phone: "Telefono",
        guests: "Numero di Ospiti",
        date: "Data Preferita",
        message: "Messaggio",
        messagePlaceholder: "Richieste speciali, allergie, occasioni particolari...",
        submit: "Invia Richiesta",
        submitWhatsApp: "Prenota via WhatsApp",
        thanks: "Grazie!",
        thanksText: "Ti contatteremo presto per confermare la prenotazione."
      }
    },
    footer: {
      description: "Ristorante Mezzaluna - Cucina italiana e specialità di pesce, carne e pizza in un'atmosfera familiare e accogliente a Lavertezzo Piano.",
      quickLinks: "Link Rapidi",
      contacts: "Contatti",
      rights: "Tutti i diritti riservati.",
      madeWith: "Fatto con",
      and: "e",
      in: "a Lavertezzo"
    }
  },
  de: {
    nav: {
      home: "Home",
      about: "Über Uns",
      menu: "Menü",
      specials: "Spezialitäten",
      hours: "Öffnungszeiten",
      contact: "Kontakt",
      book: "Reservieren"
    },
    hero: {
      welcome: "Willkommen im",
      features: [
        { title: "Italienische Küche", subtitle: "Tradition und Qualität" },
        { title: "Holzofen", subtitle: "Authentische Pizza" },
        { title: "Familie", subtitle: "Herzliche Gastfreundschaft" }
      ],
      cta1: "Tisch reservieren",
      cta2: "Jetzt anrufen",
      scroll: "Scrollen"
    },
    about: {
      subtitle: "Über Uns",
      title: "Ein Familiengeführtes Restaurant",
      welcome: "Die Leidenschaft für die Küche",
      p1: "Das Ristorante Mezzaluna entstand aus der Liebe zur guten italienischen Küche, der Liebe zum Detail und dem Wunsch, dass sich jeder Gast wie zu Hause fühlt.",
      p2: "Wir bieten sorgfältig zubereitete Gerichte mit ausgewählten Zutaten: Fisch- und Fleischspezialitäten, hausgemachte Pasta, Pizza aus dem Holzofen, Wild, Fondue Chinoise und hausgemachte Desserts.",
      p3: "Ein einladendes Ambiente, eine entspannte Atmosphäre und eine ehrliche Küche zum Genießen in Gesellschaft.",
      quote: "Wo die Leidenschaft für die Küche in jedem Gericht spürbar ist.",
      stats: {
        fish: "Frischer Fisch",
        meat: "Qualitätsfleisch",
        pizza: "Holzofen",
        location: "Lavertezzo"
      }
    },
    menu: {
      subtitle: "Unser Menü",
      title: "Eine Küche, die Tradition und Geschmack Vereint",
      description: "Jedes Gericht wird sorgfältig zubereitet, mit ausgewählten Zutaten und unter Berücksichtigung der Saisonalität.",
      daily: "Jeden Tag bieten wir auch unser Tagesmenü an.",
      cta: "Tisch Reservieren",
      allergyNote: "Bei Allergien oder Unverträglichkeiten bitten wir unsere Gäste, das Personal vor der Bestellung zu informieren."
    },
    specials: {
      subtitle: "Unsere Spezialitäten",
      title: "Besondere Anlässe",
      chicken: {
        title: "Hühnchen im Korb",
        subtitle: "Nur auf Reservierung - Freitag Abend 20. März",
        description: "Ein Klassiker unserer Küche, knusprig und saftig serviert."
      },
      festapapa: {
        title: "Vatertag",
        subtitle: "Donnerstag 19. März",
        description: "Ein spezielles Menü um alle Väter zu feiern."
      },
      valentine: {
        title: "Valentinstag",
        subtitle: "Spezielles Menü für Paare",
        description: "Ein romantisches Menü, um die Liebe mit den Aromen unserer Küche zu feiern."
      }
    },
    reviews: {
      subtitle: "Was Man Über Uns Sagt",
      title: "Die Stimmen Unserer Gäste",
      source: "Verifizierte Google-Bewertungen",
      seeAll: "Alle Bewertungen auf Google ansehen"
    },
    hours: {
      subtitle: "Wann Sie Uns Finden",
      title: "Öffnungszeiten",
      weekly: "Wöchentliche Öffnungszeiten",
      today: "Heute",
      services: "Unsere Spezialitäten",
      note: "Wichtiger Hinweis",
      noteText: "Für größere Gruppen oder besondere Anlässe empfehlen wir eine Vorausbuchung."
    },
    contact: {
      subtitle: "Besuchen Sie Uns",
      title: "Reservieren Sie Ihren Tisch",
      info: "Kontaktinformationen",
      phone: "Telefon",
      email: "E-Mail",
      address: "Adresse",
      facebook: "Folgen Sie uns auf Facebook",
      form: {
        title: "Reservierung Anfragen",
        name: "Name",
        email: "E-Mail",
        phone: "Telefon",
        guests: "Anzahl der Gäste",
        date: "Bevorzugtes Datum",
        message: "Nachricht",
        messagePlaceholder: "Besondere Wünsche, Allergien, besondere Anlässe...",
        submit: "Anfrage Senden",
        submitWhatsApp: "Via WhatsApp reservieren",
        thanks: "Danke!",
        thanksText: "Wir werden Sie bald kontaktieren, um die Reservierung zu bestätigen."
      }
    },
    footer: {
      description: "Ristorante Mezzaluna - Italienische Küche und Spezialitäten aus Fisch, Fleisch und Pizza in familiärer und einladender Atmosphäre in Lavertezzo Piano.",
      quickLinks: "Schnelllinks",
      contacts: "Kontakt",
      rights: "Alle Rechte vorbehalten.",
      madeWith: "Gemacht mit",
      and: "und",
      in: "in Lavertezzo"
    }
  },
  en: {
    nav: {
      home: "Home",
      about: "About Us",
      menu: "Menu",
      specials: "Specials",
      hours: "Hours",
      contact: "Contact",
      book: "Book"
    },
    hero: {
      welcome: "Welcome to",
      features: [
        { title: "Italian Cuisine", subtitle: "Tradition and quality" },
        { title: "Wood-fired Oven", subtitle: "Authentic pizza" },
        { title: "Family", subtitle: "Warm hospitality" }
      ],
      cta1: "Book a table",
      cta2: "Call now",
      scroll: "Scroll"
    },
    about: {
      subtitle: "About Us",
      title: "A Family-Run Restaurant",
      welcome: "Passion for Cooking",
      p1: "Ristorante Mezzaluna was born from the love of good Italian cuisine, attention to detail and the desire to make every guest feel at home.",
      p2: "We offer carefully prepared dishes with quality ingredients: fish and meat specialties, handmade pasta, wood-fired pizza, game, Fondue Chinoise and homemade desserts.",
      p3: "A welcoming atmosphere, a relaxing ambiance and honest cuisine to enjoy with company.",
      quote: "Where passion for cooking can be felt in every dish.",
      stats: {
        fish: "Fresh Fish",
        meat: "Quality Meat",
        pizza: "Wood-fired Oven",
        location: "Lavertezzo"
      }
    },
    menu: {
      subtitle: "Our Menu",
      title: "A Cuisine that Combines Tradition and Taste",
      description: "Each dish is prepared with care, using selected ingredients and respecting seasonality.",
      daily: "Every day we also offer our daily menu.",
      cta: "Book a Table",
      allergyNote: "In case of allergies or food intolerances, please inform our staff before ordering."
    },
    specials: {
      subtitle: "Our Specials",
      title: "Special Occasions",
      chicken: {
        title: "Basket Chicken",
        subtitle: "Reservation only - Friday evening March 20",
        description: "A classic of our cuisine, served crispy and succulent."
      },
      festapapa: {
        title: "Father's Day",
        subtitle: "Thursday March 19",
        description: "A special menu to celebrate all fathers."
      },
      valentine: {
        title: "Valentine's Day",
        subtitle: "Special menu for couples",
        description: "A romantic menu to celebrate love with the flavors of our cuisine."
      }
    },
    reviews: {
      subtitle: "What They Say About Us",
      title: "The Voices of Our Guests",
      source: "Verified Google reviews",
      seeAll: "See all reviews on Google"
    },
    hours: {
      subtitle: "When to Find Us",
      title: "Opening Hours",
      weekly: "Weekly Hours",
      today: "Today",
      services: "Our Specialties",
      note: "Important Note",
      noteText: "For large groups or special occasions, we recommend booking in advance."
    },
    contact: {
      subtitle: "Come Visit Us",
      title: "Book Your Table",
      info: "Contact Information",
      phone: "Phone",
      email: "Email",
      address: "Address",
      facebook: "Follow us on Facebook",
      form: {
        title: "Request a Reservation",
        name: "Name",
        email: "Email",
        phone: "Phone",
        guests: "Number of Guests",
        date: "Preferred Date",
        message: "Message",
        messagePlaceholder: "Special requests, allergies, special occasions...",
        submit: "Send Request",
        submitWhatsApp: "Book via WhatsApp",
        thanks: "Thank you!",
        thanksText: "We will contact you soon to confirm your reservation."
      }
    },
    footer: {
      description: "Ristorante Mezzaluna - Italian cuisine and fish, meat and pizza specialties in a family and welcoming atmosphere in Lavertezzo Piano.",
      quickLinks: "Quick Links",
      contacts: "Contacts",
      rights: "All rights reserved.",
      madeWith: "Made with",
      and: "and",
      in: "in Lavertezzo"
    }
  }
};
